var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"am-button-icon",class:[
		`am-button-icon--${_vm.size}`
	],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('am-icon',{staticClass:"am-button-icon__icon",attrs:{"size":_vm.size,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }